import { ENV } from '../config/env.js';

/**
 * The single API scope requested for every interactive sign-in. The API
 * (`AZURE_API_AUDIENCE`) and the SPA (`VITE_AZURE_API_SCOPE`) must agree.
 */
export const API_SCOPES: readonly string[] = [ENV.apiScope];

export function loginRequest(): { readonly scopes: readonly string[] } {
  return { scopes: API_SCOPES };
}
